import { useMemo } from "react";

import { useTranslate } from "@similarweb/i18n-provider";
import { CheckCircle } from "@similarweb/icons";
import type { ColumnType } from "@similarweb/pro-logic-components";
import { colorsPalettes } from "@similarweb/styles";

import type { DomainCellProps } from "./DomainCell";
import { DomainCell } from "./DomainCell";

export type DomainInfo = Omit<DomainCellProps, "domain"> & {
    value: DomainCellProps["domain"];
};

export const useDomainColumn = ({ dataAutomation }: Pick<DomainCellProps, "dataAutomation">) => {
    const { translate } = useTranslate();

    return useMemo(
        () =>
            ({
                dataIndex: "domain",
                minWidth: 180,
                title: translate("common.domain"),
                render: ({ icon, isPrimary, value }: DomainInfo) => (
                    <DomainCell
                        dataAutomation={dataAutomation}
                        icon={icon}
                        isPrimary={isPrimary}
                        domain={value}
                    >
                        {isPrimary ? <CheckCircle color={colorsPalettes.blue[400]} /> : null}
                    </DomainCell>
                ),
            }) satisfies ColumnType<{ domain: DomainInfo }>,
        [dataAutomation, translate],
    );
};
